import * as constants from './index';

export * from './index';

export default constants;

export namespace Funkey {
    export const NAME = 'Funkey';
    export const BIZZ_SLUG = 'funkey';
    export const EMAIL_DOMAIN = 'funkey.be';

    export namespace Address {
        export const STREET = 'Antoon Catriestraat';
        export const HOUSE_NUMBER = '1B';
        export const POSTAL_CODE = '9031';
        export const CITY = 'Drongen';
    }

    export const INFO_EMAIL = 'info@funkey.be';

    export namespace InvoiceInfo {
        export const VAT_NUMBERS = {
            BE: 'BE 0680.777.078',
        } as const;

        export const STREET = 'Clematisstraat';
        export const HOUSE_NUMBER = '10';
        export const POSTAL_CODE = '9000';
        export const CITY = 'Gent';
    }
}
